import { AfsPageOptions } from '../../shared/types/ast';
import { getConfig, getFeatureStatus } from '../config';
import { UNLEASH_FEATURE_NAMES } from '../../shared/unleash/feature-names';

const STYLE_ID = {
    DESKTOP: '5268803732',
    MOBILE: '4302767753',
};

const afs = {
    pubId: 'partner-pub-4700071094164059',
    query: 'search',
};

export function triggerGoogleAfs(optionalQuery?: string) {
    if (typeof window === 'undefined') return;

    const googleAfs = getFeatureStatus(UNLEASH_FEATURE_NAMES.googleAFSEnabled);
    if (!googleAfs) return;
    const { deviceType, pageType, vertical } = getConfig();

    const query =
        optionalQuery || new URLSearchParams(window.location.search).get('q');

    if (query && pageType === 'result' && vertical === 'bap') {
        const pageOptions: AfsPageOptions = {
            pubId: afs.pubId,
            query: query,
            styleId:
                deviceType === 'mobile' ? STYLE_ID.MOBILE : STYLE_ID.DESKTOP,
            adsafe: 'high',
            resultsPageBaseUrl: window.location.href,
            resultsPageQueryParam: 'q',
            number: 1,
        };

        const adblock1 = {
            container: 'afscontainer1',
        };

        try {
            window._googCsa('ads', pageOptions, adblock1);
        } catch (error) {
            console.error('Error in google ad sense [for search]: ', error);
        }
    }
}
